import tableConfig from '@/views/pages/tableConfig'

export default function config() {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'direction', label: 'Direction', sortable: true },
    { key: 'dc_amount', label: 'Dc amount', sortable: true },
    { key: 'phd_amount', label: 'Phd amount', sortable: true },
    { key: 'dc_student', label: 'Dc student', sortable: true },
    { key: 'phd_student', label: 'Phd student', sortable: true },
    { key: 'independent_student', label: 'Independent student', sortable: true },
  ]

  return {
    tableColumns,
    ...tableConfig('quote', { perPage: 1000 }),
  }
}
